import { buildAroValidationContext } from './aroValidationContext'
import { buildEmptyValueRule } from './validationRuleBuilders'

/**
 * Builds the Inherited IRA validation context by extending the shared ARO base context
 * with decedent-specific fields and IRA-specific rules.
 *
 * Shared fields (recordkeeper, tpa, planSponsor, planEin, etc.) are inherited from
 * buildAroValidationContext unchanged. Decedent name fields reuse the same compiled
 * regex rule objects from the corresponding participant name fields; field-name-specific
 * emptyValue messages are overridden where the error text differs.
 *
 * @param {string} userAudience - e.g. 'Recordkeeper', 'TPA'
 * @returns {object} Validation context for Inherited IRA listeners and pure validators
 */
export function buildInheritedIraValidationContext(userAudience) {
  const base = buildAroValidationContext(userAudience)

  return {
    // ── All shared ARO fields (recordkeeper, tpa, planSponsor, planName, planEin,
    //    planNumber, planIdNumber, firstName, middleName, lastName, addressLine1,
    //    addressLine2, city, ssn, emailAddress, IRA amounts, audience flags,
    //    and pure-validator formats: ssnFormat, dobFormat, zipCodeFormat) ────────
    ...base,

    // ── Inherited IRA-specific field rules ────────────────────────────────────
    doAmtsIncludeRMDAmt: {
      includeRmdAmt: {
        re: /^(?:N)$/i,
        error: "Must be 'N' for no",
      },
    },

    // Decedent name fields share the same compiled rule objects as the matching
    // participant name fields; only the emptyValue message is overridden.
    decedentFirstName: {
      ...base.firstName,
      emptyValue: buildEmptyValueRule('Decedent first name'),
    },
    decedentMiddleName: base.middleName,
    // decedentLastName uses validator type 'lastName' in the field config, so it
    // is handled by the externalConstraint('lastName', ...) registration and does
    // not need a separate context entry.
  }
}
